import { useContext }from "react";
import { Context } from "@entities/context"
import { useNavigate } from "react-router-dom";
import { createPortal } from "react-dom";

export default function Portal() {
	const el = document.getElementById('header');
	if (!el) return null;

	return createPortal(<Header />, el);
}


export function Header() {
    const { storage } = useContext(Context)
	const navigate = useNavigate();
	const hasPin = !!storage.get("pin");

	const handleLogoClick = () => {
		navigate(hasPin ? "/dashboard" : "/welcome");
	};

	const handleSignOut = () => {
		storage.set("pin");
		navigate("/welcome", { replace: true });
	};

	return (
		<div className="flex items-center justify-between w-full sm:items-start">
			<img
				onClick={handleLogoClick}
				src={import.meta.env.BASE_URL+"images/logo.svg"}
				alt={document.title}
				className="-ml-4 cursor-pointer"
				width="300"
				style={{ maxWidth: "75%" }}
			/>

			{hasPin && (
				<button
					onClick={handleSignOut}
					className="py-6 text-sm text-gray-500 truncate cursor-pointer hover:text-primary focus:outline-none"
				>
					Sign Out
					<i
						className="relative ml-1 text-lg fas fa-times-circle sm:ml-2"
						style={{ top: "2px" }}
					/>
				</button>
			)}
		</div>
	);
}
